import {
    DialogProps as MuiDialogProps, Dialog as MuiDialog,
    DialogTitle as MuiDialogTitle, DialogActions as MuiDialogActions,
    DialogContent as MuiDialogContent, DialogContentText as MuiDialogContentText,
    Breakpoint,
    useTheme,
    useMediaQuery,
    Stack
} from "@mui/material";

import { CodeProvider } from "../contexts/code-context";
import useModalContext from "../hooks/use-modal-context";
import { ModalCodeProps } from "../shared/types";
import useOnClose from "../hooks/use-on-close-effect";

export interface DialogProps extends Omit<MuiDialogProps, "open" | "onClose">, ModalCodeProps {
    size?: Breakpoint,
    fullHeight?: boolean,
    onClose?: () => any
}

export default function Dialog({
    code,
    children,
    closeAfterTransition = true,
    size,
    sx,
    fullHeight,
    onClose,
    ...props
}: DialogProps) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down(size ?? "md"));

    const widthProps = size && { maxWidth: size, fullWidth: true }
    const fullScreenProps = size && { fullScreen };

    const { open, handleClose } = useModalContext(code);

    useOnClose(open, onClose);

    return <MuiDialog
        {...widthProps}
        {...fullScreenProps}
        sx={{ zIndex: 1200, ...sx }}
        {...props}
        open={open}
        onClose={handleClose}
        closeAfterTransition={closeAfterTransition}
        disableRestoreFocus
        slotProps={{
            ...props.slotProps,
            paper: {
                sx: {
                    overflow: "hidden",
                    minHeight: fullHeight ? "90vh" : undefined,
                    ...(props.slotProps?.paper as any)?.sx
                },
                ...props.slotProps?.paper
            },
        }}
    >
        <CodeProvider code={code}>
            <Stack flex={1} overflow={"auto"}>
                {children}
            </Stack>
        </CodeProvider>
    </MuiDialog>
}

Dialog.Title = MuiDialogTitle;
Dialog.Actions = MuiDialogActions;
Dialog.Content = MuiDialogContent;
Dialog.ContentText = MuiDialogContentText;